import { TmxState } from "@idw-types/state/tmx-state"
import { TmxActions, TmxProfillingActionTypes } from "@redux/actions/tmx-actions"

export const initialTmxState: TmxState = {
    isTmxProfilingCompleted: false,
    error: null
}

export const tmxReducer = (state: TmxState = initialTmxState, action: TmxActions) => {
    switch (action.type) {
        case TmxProfillingActionTypes.SET_TMX_PROFILING_IS_COMPLETED:
            return {
                ...state,
                error:  null,
                isTmxProfilingCompleted: action.payload.isTmxProfilingCompleted
            };

        case TmxProfillingActionTypes.SET_TMX_LOAD_ERROR:
            return {
                ...state,
                isTmxProfilingCompleted: false,
                error: action.payload.error
            };

        default:
            return state;
    }
}